import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Typography } from '@repo/ui/Typography';
import { Fragment } from 'react';
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
import { getAllChildrenStrings, markNestedTypes } from '../../utils';
function slugify(str: string): string {
  return str.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
}
const headingStyleMap: Record<number, string> = {
  1: 'title',
  2: 'text.largeBold',
  3: 'text.large',
  4: 'text.bold',
  5: 'text',
  6: 'text.small'
};
export type ContentHeadingProps = StructuredContentDocumentWithRenderer<{
  level: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 5 | 4 | 3 | 2 | 1 | 0;
  children: StructuredContentDocument | [string];
}>;
export const ContentHeading = sccProps => {
  const $ = _c(13);
  const {
    props
  } = sccProps;
  const component = `h${props.level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  const variant = headingStyleMap[props.level];
  let t0;
  if ($[0] !== sccProps) {
    const childrenString = getAllChildrenStrings(sccProps as StructuredContentDocument);
    t0 = slugify(childrenString);
    $[0] = sccProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slugifiedId = t0;
  const id = props.level === 2 ? slugifiedId : undefined;
  const t1 = variant as Parameters<typeof Typography>[0]['variant'];
  const t2 = `content-heading-${slugifiedId}`;
  let t3;
  if ($[2] !== id) {
    t3 = id && {
      id
    };
    $[2] = id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      lineHeight: "inherit !important"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.children) {
    t5 = [props.children].flat().map(_temp);
    $[5] = props.children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== component || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <Typography as={component} variant={t1} data-testid={t2} {...t3} css={t4}>{t5}</Typography>;
    $[7] = component;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(child, idx) {
  if (typeof child === "string") {
    return <span key={`content-heading-${idx}`} className={css({
      whiteSpace: "pre-wrap"
    })}>{child}</span>;
  }
  return <Fragment key={`content-heading-doc-${idx}`}>{renderStructuredContent(markNestedTypes(child))}</Fragment>;
}